module.exports = __webpack_public_path__ + "img/brain_round.c9097c89.svg";